import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AssetStyle } from "../../../model/internal/assetInfo";

import {
  faSquareFull,
  faCircle,
  faStickyNote,
  faArrowRight,
  faEyeDropper,
} from "@fortawesome/free-solid-svg-icons";

const iconMap: Record<string, any> = {
  faStickyNote: faStickyNote,
  faSquareFull: faSquareFull,
  faCircle: faCircle,
  faArrowRight: faArrowRight,
  faEyeDropper: faEyeDropper,
};

interface AssetIconProps {
  assetStyle: AssetStyle;
}

const AssetIcon = ({ assetStyle }: AssetIconProps) => {
  return (
    <>
      {assetStyle.icon ? (
        <FontAwesomeIcon icon={iconMap[assetStyle.icon]} />
      ) : (
        <i className={`icon-${assetStyle.class}${assetStyle.class === "node" ? "-tool" : ""}`} />
      )}
    </>
  );
};

export default AssetIcon;
